/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextCellModelExport, _super);
    function TextCellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.af = null;
        _this.ae = null;
        return _this;
    }
    TextCellModelExport.prototype.get_ac = function () {
        return "TextCell";
    };
    TextCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
        a.l("textValue : \"" + this.af + "\", ");
        a.l("formatString : \"" + this.ae + "\", ");
    };
    TextCellModelExport.$t = markType(TextCellModelExport, 'TextCellModelExport', CellModelExport.$);
    return TextCellModelExport;
}(CellModelExport));
export { TextCellModelExport };
//# sourceMappingURL=TextCellModelExport.js.map
